/**
 * The reserved "Unassigned" metro, seeded by migration with an all-zeros id.
 * organization-service returns it in `items` like any other row, and an office
 * whose zip is in no metro carries this id once the monolith's
 * `GOTU-6007-sales-metros-switch` is on. Until then the `getSalesMetros` thunk
 * drops it from the RAM list.
 */
export const UNASSIGNED_SALES_METRO_ID = '000000000000000000000000';
